var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPromoNoItem(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 143,
    height: 168,
    viewBox: "0 0 143 168",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1560_9376)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.4626 167.633C111.221 167.633 136.156 162.752 136.156 156.731C136.156 150.71 111.221 145.829 80.4626 145.829C49.7042 145.829 24.7695 150.71 24.7695 156.731C24.7695 162.752 49.7042 167.633 80.4626 167.633Z",
    stroke: "#1A1A1A",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.238 44.43H142.612C142.612 44.43 144.227 26.6198 124.253 28.6754C104.279 30.731 98.4258 37.6906 98.4258 37.6906L113.238 44.43Z",
    fill: "#090A0A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.6602 124.143V42.5946C36.6602 38.8952 38.1302 35.3473 40.7468 32.7315C43.3634 30.1156 46.9123 28.646 50.6128 28.646H124.268C124.268 28.646 113.253 29.593 113.253 44.4006V127.292C113.253 127.292 112.731 139.611 97.7067 138.018C82.6819 136.425 36.6749 134.854 36.6749 134.854L36.6602 124.143Z",
    fill: "url(#paint0_linear_1560_9376)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4508 120.729H87.0736C87.0736 120.729 83.9452 135.169 97.6849 138.017H32.8638C32.8638 138.017 21.6136 135.844 22.4508 120.729Z",
    fill: "url(#paint1_linear_1560_9376)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.875 75.7409C138.265 75.7409 142.634 71.3727 142.634 65.9842C142.634 60.5958 138.265 56.2275 132.875 56.2275C127.485 56.2275 123.115 60.5958 123.115 65.9842C123.115 71.3727 127.485 75.7409 132.875 75.7409Z",
    stroke: "#CC6C69",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.101 0.491699L8.92969 4.86716L23.3083 21.0035L30.101 0.491699Z",
    stroke: "#EAEAEA",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.2086 37.6902C21.2581 37.6636 15.4635 39.5905 10.7146 43.1751C5.96573 46.7596 2.52521 51.8035 0.921458 57.5322C-0.68229 63.2608 -0.360586 69.3573 1.83718 74.8855C4.03494 80.4136 7.98724 85.0677 13.087 88.1328C12.6094 88.4877 12.2509 88.9792 12.0589 89.5423L0.882105 123.746C0.645747 124.469 0.706376 125.257 1.05063 125.935C1.39489 126.614 1.9946 127.128 2.71798 127.365L7.92452 129.068C8.28229 129.185 8.6596 129.23 9.03487 129.201C9.41015 129.172 9.77601 129.07 10.1116 128.899C10.4471 128.729 10.7458 128.494 10.9905 128.208C11.2351 127.922 11.421 127.591 11.5375 127.233L22.7217 93.0221C22.8529 92.6022 22.888 92.1581 22.8245 91.7227C24.2808 91.9633 25.7545 92.0836 27.2306 92.0825C34.4455 92.0825 41.365 89.2172 46.4667 84.1169C51.5685 79.0166 54.4346 72.0992 54.4346 64.8863C54.4346 57.6735 51.5685 50.756 46.4667 45.6558C41.365 40.5555 34.4455 37.6902 27.2306 37.6902H27.2086Z",
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.2079 86.3489C38.7869 86.3489 48.1736 76.965 48.1736 65.3893C48.1736 53.8136 38.7869 44.4297 27.2079 44.4297C15.6288 44.4297 6.24219 53.8136 6.24219 65.3893C6.24219 76.965 15.6288 86.3489 27.2079 86.3489Z",
    fill: "url(#paint2_linear_1560_9376)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1327 63.5981C18.4508 63.5981 19.5194 62.5298 19.5194 61.2121C19.5194 59.8944 18.4508 58.8262 17.1327 58.8262C15.8146 58.8262 14.7461 59.8944 14.7461 61.2121C14.7461 62.5298 15.8146 63.5981 17.1327 63.5981Z",
    fill: "#090A0A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.2773 63.5981C38.5954 63.5981 39.6639 62.5298 39.6639 61.2121C39.6639 59.8944 38.5954 58.8262 37.2773 58.8262C35.9592 58.8262 34.8906 59.8944 34.8906 61.2121C34.8906 62.5298 35.9592 63.5981 37.2773 63.5981Z",
    fill: "#090A0A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8535 66.3364H30.5581",
    stroke: "#090A0A",
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1560_9376",
    x1: 80,
    y1: 138,
    x2: 80,
    y2: 29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC629"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#F8D98F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#FBEABF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#FDF5E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FFFCF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#FFFEFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#FEFAF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#FDF4E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#FBECC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#F9E1AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#F6D385"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC629"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1560_9376",
    x1: 22.4067,
    y1: 129.377,
    x2: 97.6923,
    y2: 129.377,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC6C69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#E4A15F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3C358"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1560_9376",
    x1: 6.24219,
    y1: 65.3893,
    x2: 48.1736,
    y2: 65.3893,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC629"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1560_9376"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 143,
    height: 168,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPromoNoItem);
export default __webpack_public_path__ + "static/media/promo-no-item.2fc9ad7f5422ae0dd37cd9afdb971912.svg";
export { ForwardRef as ReactComponent };